import React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { Filter } from '~/evifields/src/types/Filter';

import { FilterChip } from './FilterChip';
import { Field, FieldId } from './types';

interface Props {
  enableFilterViews?: boolean;
  disableRemove: boolean;
  fields: Record<FieldId, Field>;
  filters: Filter[];
  onRemoveFilter: (_filterToRemove: Filter) => void;
  onUpdateFilter: (_updatedFilter: Filter) => void;
}

export const FilterChips = ({
  enableFilterViews = false,
  disableRemove,
  fields,
  filters,
  onRemoveFilter,
  onUpdateFilter,
}: Props) => {
  const intl = useIntl();

  if (filters.length === 0) {
    return (
      <Text preset="description">
        {intl.formatMessage({
          id: 'Filters_Deprecated.FilterChips.noFiltersSelected',
          defaultMessage: 'No filters selected',
          description: 'Message displayed when no filters are applied',
        })}
      </Text>
    );
  }

  return (
    <Layout role="list" wrap preset="chips">
      {filters.map(
        (filter) =>
          filter.fieldId && (
            <FilterChip
              key={filter.id}
              disableRemove={disableRemove}
              enableFilterViews={enableFilterViews}
              field={fields[filter.fieldId]}
              filter={filter}
              hasError={filter.hasError}
              onChange={onUpdateFilter}
              onRemove={onRemoveFilter}
            />
          ),
      )}
    </Layout>
  );
};
